/**
 * 複数のフォームがある画面でフォームに変更されている場合に確認ダイアログを表示する
 * this.$refs.form.$refs.observer.flags.changedを監視する
 */
export default function confirmIfFormsChanged(formRef = 'form') {
  return {
    data() {
      return {
        /**
       * こちらがtrueの場合は画面遷移時に確認ダイアログを表示しない
       * formのresetを呼んだ後のnextTickで遷移してもchangedがtrueになるのを待てないのでその代替手段
       */
        canLeave: false,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.setRefWatch()
      })
    },
    // フォームが更新されたら監視も更新する
    updated() {
      this.setRefWatch()
    },
    async beforeRouteLeave(to, from, next) {
      if (this.canLeave) {
        next()
        return
      }
      const isChanged = this.$refs[formRef]?.some(form => form.$refs.observer?.flags.changed) || false
      if (isChanged) {
        const allowLeave = await this.$bvModal.msgBoxConfirm('入力内容が保存されておりませんが、画面から離れてもよろしいでしょうか？', {
          okTitle: '離れる',
          cancelTitle: '入力に戻る',
          centered: true,
        })
        if (!allowLeave) {
          next(false)
          return
        }
      }
      next()
    },
    methods: {
      setRefWatch() {
        this.$watch(
          () => {
            return this.$refs[formRef]?.some(form => form.$refs.observer?.flags.changed) || false
          },
          (val) => {
            const changed = val
            this.canLeave = !changed
          }
        )
      },
    },
  }
}
